import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
// Import Local Styles
import styles from './step.css';

const Step = ({ isCurrentStep, to, isEnabled, children }) => {
    // if isEnabled return Router Link
    if (isEnabled) {
        return (
            <Link
                className={`${
                    styles.link} ${
                    isCurrentStep ? styles['link--current'] : ''}
                   `}
                to={to}
            >
                {children}
            </Link>
        );
    }
    return (
        <span
            className={`${
                styles.link} ${
                styles['link--disabled']} ${
                isCurrentStep ? styles['link--current'] : ''}
                `}
        >
            {children}
        </span>
    );
};

Step.propTypes = {
    isEnabled: PropTypes.bool,
    isCurrentStep: PropTypes.bool,
    to: PropTypes.string
};


export default Step;
